/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Peripherals from '@appblocks/codegeneration/Peripherals';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const NAME = feature.getSettingValue('NAME');
    const PIN = feature.getSettingValue('PIN');
    const STATE = feature.getSettingValue('STATE');
    const PULL = feature.getSettingValue('PULL');
    const featureId = feature.getID();

    const peripherals = Peripherals.getPin(PIN, feature.project.device.id)?.peripherals;
    const gpioNum = PIN;
    // if (peripherals) {
    //     gpioNum = peripherals.filter(p => p.peripheralType === 'gpio')[0].peripheralPort;
    // }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
const ${NAME}_pin = {
    gpio: ${gpioNum},
    direction: "OUTPUT",
    initialState: ${STATE === '1' ? '1' : '0'},
    pull: ${`'${PULL}'` || 'null'},
}`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "NAME": ${NAME}_pin.initialState,
});`,
    });
    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `var_${NAME}_update_completed(simulator.context["${featureId}"]["NAME"]);`,
    });
    blocks.push({
        location: `var_${NAME}_set`,
        blockType: BlockType.CODE,
        template: `ioLineSet("${featureId}", "NAME", value)`,
    });

    return blocks;
};
